<script setup>
    import { computed } from 'vue';
    import ScoreAchievement from '@/components/result/ai-literacy-2026/ScoreAchievement.vue';  
    import AchievementTable from '@/components/result/ai-literacy-2026/AchievementTable.vue'; 
    import { resolveAchievementLevel } from '@/components/result/ai-literacy-2026/data/reportLogic';

    const props = defineProps({
        studentData: Object
    });

    // 성취수준: DB 값(achievement_level) 우선, 없으면 총점으로 계산 (기준 점수는 reportData.ACHIEVEMENT_CUTS)
    const schulType = computed(() => props.studentData?.schul_type || 'E');
    const achievementLevel = computed(() =>
        resolveAchievementLevel(schulType.value, props.studentData?.achievement_level, props.studentData?.total_score)
    );
</script>
<template>
    <div class="report-inner">   
        <div class="card-wrap">
            <ScoreAchievement 
                v-if="props.studentData"
                :schulType="schulType"
                :achievementLevel="achievementLevel"
                :totalScore="Number(props.studentData.total_score) || 0"
                :studentData="props.studentData"
            />
            <AchievementTable 
                v-if="props.studentData"
                userRole="student"
                :studentLevel="achievementLevel"
                :schulType="schulType"
            />     
        </div>
    </div>
</template>
